import { render, staticRenderFns } from "./CategoryOrPmManagement.vue?vue&type=template&id=3ff9995e&scoped=true&"
import script from "./CategoryOrPmManagement.vue?vue&type=script&lang=js&"
export * from "./CategoryOrPmManagement.vue?vue&type=script&lang=js&"
import style0 from "./CategoryOrPmManagement.vue?vue&type=style&index=0&id=3ff9995e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff9995e",
  null
  
)

export default component.exports